import BaseCRUDService from './BaseCRUDService';

class PatientService extends BaseCRUDService {
  getBaseURL = () => {
    return '~/api/patient';
  };
}

export default new PatientService();
